import { render, staticRenderFns } from "./showTempDomainModal.vue?vue&type=template&id=da523c06&scoped=true"
import script from "./showTempDomainModal.vue?vue&type=script&lang=js"
export * from "./showTempDomainModal.vue?vue&type=script&lang=js"
import style0 from "./showTempDomainModal.vue?vue&type=style&index=0&id=da523c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da523c06",
  null
  
)

export default component.exports